import { Link, Text } from 'bold-ui'
import { Fragment, useState } from 'react'

interface ExpandableTextProps {
  texto: string
}

export function ExpandableText({ texto }: Readonly<ExpandableTextProps>) {
  const [expandido, setExpandido] = useState(false)
  const limiteCaracteres = 60

  if (texto.length <= limiteCaracteres) return <Text>{texto}</Text>

  return (
    <Fragment>
      <Text component='span'>{expandido ? texto : `${texto.substring(0, limiteCaracteres)}...`}</Text>
      <Link
        onClick={() => setExpandido(!expandido)}
        style={{ cursor: 'pointer', marginLeft: '0.5rem', whiteSpace: 'nowrap' }}
      >
        {expandido ? 'Ver menos' : 'Ver mais'}
      </Link>
    </Fragment>
  )
}
